import React from "react";
import smartlogo from "../assests/images/short_log-cdp.png";
import "./styles/Loader.scss";
import { useState, CSSProperties } from "react";
import BounceLoader from "react-spinners/BounceLoader";
function Loader() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#97144d");
  return (
    <div className={"mainloader"}>
      <BounceLoader
        color={color}
        loading={loading}
        // cssOverride={override}
        size={200}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default Loader;
